export default "__VITE_ASSET__LDNu_8eT__"